module.exports = {"530302001":"南宁街道","530302002":"建宁街道","530302003":"白石江街道","530302004":"寥廓街道","530302005":"西城街道","530302006":"益宁街道","530302007":"文华街道","530302008":"太和街道","530302009":"潇湘街道","530302010":"翠峰街道","530302011":"三宝街道","530302012":"沿江街道","530302013":"珠街街道","530302102":"越州镇","530302103":"东山镇","530302104":"茨营镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530302.json
// module id = 2553
// module chunks = 0